<template>
    <div id="create_qrcode" class="dir_top_nowrap cross_center">
        <vue-qr
            colorDark="#000"
            colorLight="white"
            backgroundColor="white"
            backgroundDimming="white"
            logoBackgroundColor="white"
            :qid="data.qid"
            :correctLevel="data.correctLevel"
            :text="data.text"
            :logoSrc="data.logoSrc ? data.logoSrc + '?' + dayjs().unix : ''"
            :logoScale="data.logoScale"
            :logoMargin="data.logoMargin"
            :size="data.size"
            :margin="data.margin"
            :callback="callback"
            :style="{ display: qrcodeShow ? '' : 'none' }"
        ></vue-qr>
        <div style="text-align: center" v-if="downloadShow">
            <a-button
                type="link"
                :size="downloadButtonSize"
                @click="downImgFile(fileName + '.png', dataArr)"
            >
                {{ downloadButtonName }}
            </a-button>
        </div>
    </div>
</template>

<script>
import vueQr from 'vue-qr';
import dayjs from 'dayjs';
export default {
    // 二维码工具
    name: 'create_qrcode',
    props: {
        // 当前群码信息
        data: {
            type: Object,
            default: () => {
                return {
                    qid: '1',
                    correctLevel: 3,
                    text: '未设置内容',
                    logoSrc: '',
                    logoScale: 0.2,
                    logoMargin: 2,
                    size: 300,
                    margin: 10
                };
            }
        },
        fileName: {
            type: String,
            default: '未命名'
        },
        downloadShow: {
            type: Boolean,
            default: () => {
                return true;
            }
        },
        downloadButtonSize: {
            type: String,
            // 参数：default / small / large
            default: 'default'
        },
        downloadButtonName: {
            type: String,
            default: '下载群码'
        },
        qrcodeShow: {
            type: Boolean,
            default: () => {
                return true;
            }
        }
    },
    components: {
        vueQr
    },
    data() {
        return {
            dataArr: {}
        };
    },
    mounted() {},
    methods: {
        dayjs,
        callback(dataUrl, id) {
            this.dataArr = {
                dataUrl: dataUrl,
                id: id
            };
            this.$emit('change', this.dataArr);
        },
        downImgFile(file_name, qrcode_data) {
            if (qrcode_data && !qrcode_data.dataUrl) return this.$message.error(`群码信息报错`);
            const base64 = qrcode_data.dataUrl.replace(/^data:image\/\w+;base64,/, '');
            // 把base64码转成buffer对象
            const dataBuffer = new Buffer(base64, 'base64');
            // dataBuffer.setAttribute("crossOrigin", "anonymous");
            const csvData = new Blob([dataBuffer]);
            // for IE
            if (window.navigator.msSaveOrOpenBlob) {
                window.navigator.msSaveOrOpenBlob(csvData, file_name);
            }
            // for Non-IE (chrome, firefox etc.)
            else {
                let a = document.createElement('a');
                document.body.appendChild(a);
                a.style = 'display: none';
                const url = window.URL.createObjectURL(csvData);
                a.href = url;
                a.download = file_name;
                a.click();
                a.remove();
                window.URL.revokeObjectURL(url);
            }
        }
    }
};
</script>

<style>
#create_qrcode > img {
    width: 100%;
}
</style>
